import React from "react";

import { useDivisionQuestion } from "screens/question/hooks";
import { Images } from "utils/Images";
import {
  Container,
  Label,
  StyledTextInput,
  Wrapper,
  OptionList,
  Option,
  CarrotImage,
  LabelWrapper,
} from "screens/question/themeB/types/list/styled";

export const DivisionQuestion = () => {
  const {
    onPress,
    divisions,
    placeholder,
    isPickerVisible,
    selectedDivision,
    setPickerVisible,
  } = useDivisionQuestion();

  const isFocused = isPickerVisible || selectedDivision?.title;
  return (
    <Container isOpen={isPickerVisible}>
      <LabelWrapper onPress={() => setPickerVisible(!isPickerVisible)}>
        <Label $isFocused={isFocused}>{placeholder}</Label>
        <StyledTextInput
          editable={false}
          $isFocused={isFocused}
          value={selectedDivision?.title || ""}
          onBlur={() => setPickerVisible(false)}
        />
        <CarrotImage source={Images.Carret} />
      </LabelWrapper>
      {isPickerVisible && (
        <Wrapper>
          {divisions.map(division => {
            const isSelected = selectedDivision?.id === division.id;
            return (
              <OptionList
                key={division.id}
                $isSelected={isSelected}
                onPress={() => onPress(division)}
              >
                <Option $isSelected={isSelected}>{division.title}</Option>
              </OptionList>
            );
          })}
        </Wrapper>
      )}
    </Container>
  );
};
